'use strict';

var LadderDetailsActionsToolbarDirective = function LadderDetailsActionsToolbarDirective() {
  return {
    restrict: 'E',
    replace: true,
    controller: 'LadderDetailsActionsToolbarController',
    template: require('../templates/ladder-details-actions-toolbar.html'),
    scope: {
      currentRow: '=',
      allRows: '=?'
    }
  };
};
LadderDetailsActionsToolbarDirective.$inject = [];
module.exports = LadderDetailsActionsToolbarDirective;